import {
  confirmOrder as confirmOrderApi,
  createOrder as createOrderApi,
  prePay as prePayApi,
} from "@/api/ai-assistant";
import { ConfirmOrderParams, ConfirmOrderResponse } from "@/api/ai-assistant/types";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

declare const WeixinJSBridge: any;

export const useConfirmOrder = () => {
  const [searchParams] = useSearchParams();
  const [confirmOrderInfo, setconfirmOrderInfo] = useState<ConfirmOrderResponse | undefined>();
  const [paying, setPaying] = useState(false);
  const skuCode = searchParams.get("skuCode") || "";
  const distributorId = searchParams.get("distributorId") || "";

  const confirmOrder = async (params: ConfirmOrderParams) => {
    const res = await confirmOrderApi(params);
    setconfirmOrderInfo(res);
  };

  const submitOrder = async () => {
    setPaying(true);
    if (!confirmOrderInfo?.confirmId) {
      Toast.show("订单不存在");
      return;
    }
    try {
      const res = await createOrderApi({
        confirmId: confirmOrderInfo.confirmId,
        userId: distributorId,
        userType: 2,
        skuCode,
        terminal: 1,
        channel: 1,
      });
      if (!res?.needPayment || !res?.orderGroupNo) {
        return;
      }
      const data = await prePayApi({
        reqId: res?.orderGroupNo,
        payChannel: "WECHAT",
      });
      if (data) {
        const obj = JSON.parse(data);
        WeixinJSBridge.invoke("getBrandWCPayRequest", obj, res => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 支付成功后跳转
            Toast.show("支付成功");
            setTimeout(() => {
              window.history.back();
            }, 1000);
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            // 支付取消
            Toast.show("支付取消");
          } else {
            // 支付失败
            Toast.show("支付失败");
            console.log("支付失败", res, "支付参数", obj);
          }
          setPaying(false);
        });
      }
    } catch (error) {
      setPaying(false);
    }
  };

  useEffect(() => {
    confirmOrder({
      skuCode,
      userType: 2,
      userId: distributorId,
      terminal: 1,
      channel: 1,
    });
  }, []);

  return {
    confirmOrderInfo,
    paying,
    submitOrder,
  };
};
